import { render, staticRenderFns } from "./HeartReactionIcon.vue?vue&type=template&id=5478747f&scoped=true"
import script from "./HeartReactionIcon.vue?vue&type=script&lang=js"
export * from "./HeartReactionIcon.vue?vue&type=script&lang=js"
import style0 from "./HeartReactionIcon.vue?vue&type=style&index=0&id=5478747f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478747f",
  null
  
)

export default component.exports